import React, { useState, useRef } from 'react';

function DetailProfilBidang({ tabs, defaultTab, children }) {
  const [activeTab, setActiveTab] = useState(defaultTab);
  const contentRefs = useRef({});

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (contentRefs.current[tab]) {
      contentRefs.current[tab].scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-3 follow-scroll">
            {/* Tabs nav */}
            <div
              className="nav flex-column nav-pills nav-pills-custom mt-5"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              {tabs.map((tab) => (
                <a
                  key={tab.id}
                  className={`nav-link mb-3 p-3 shadow ${
                    activeTab === tab.id ? 'active' : ''
                  }`}
                  onClick={() => handleTabChange(tab.id)}
                >
                  <span className="font-weight-bold text-uppercase" style={{ fontSize: '14px' }}>
                    {tab.label}
                  </span>
                </a>
              ))}
            </div>
          </div>

          <div className="col-md-9 mt-5">
            {/* Tabs content */}
            {tabs.map((tab) => (
              <div
                key={tab.id}
                ref={(el) => (contentRefs.current[tab.id] = el)}
                style={{ display: activeTab === tab.id ? 'block' : 'none' }}
              >
                {children(tab.id)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailProfilBidang;
